import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import styles from "./ProjectSingle.module.css";
import ProjectSingleImages from "./ProjectSingleImages";

const apiKey = "AIzaSyAAgFvKs3Vo5nuo_bkIY1ePkNqNsSmB33g";
const mainFolderId = "1se1WvZ297MXYbBHjl8qxIpvrRgJCv35b";

const ProjectSingle = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [mainImage, setMainImage] = useState(null);
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [projectText, setProjectText] = useState("");
  const [categories, setCategories] = useState([]);

  const headingTitle = location.pathname
    .split("/")[2] // projects/aranya-joypur
    ?.replace(/-/g, " ")
    .toUpperCase();

  const realName = slug.split("-").join(" ").toLowerCase();

  const fetchCategories = async () => {
    const url = `https://www.googleapis.com/drive/v3/files?q='${mainFolderId}' in parents and mimeType='application/vnd.google-apps.folder'&fields=files(id,name)&key=${apiKey}`;
    const res = await axios.get(url);
    return res.data.files;
  };

  const findProjectFolder = async (folderList) => {
    for (let cat of folderList) {
      const url = `https://www.googleapis.com/drive/v3/files?q='${cat.id}' in parents and mimeType='application/vnd.google-apps.folder'&fields=files(id,name)&key=${apiKey}`;
      const res = await axios.get(url);
      const match = res.data.files.find(
        f => f.name.toLowerCase() === realName
      );
      if (match) return match.id;
    }
    return null;
  };

  const fetchProjectText = async (TEXT_FOLDER_PARENT_ID) => {
    try {
      const url = `https://www.googleapis.com/drive/v3/files?q='${TEXT_FOLDER_PARENT_ID}' in parents and mimeType='text/plain'&fields=files(id,name)&key=${apiKey}`;

      const res = await axios.get(url);

      if (!res.data.files || res.data.files.length === 0) {
        console.log("No txt file found");
        return;
      }

      const txtFile = res.data.files[0];
      const contentUrl = `https://www.googleapis.com/drive/v3/files/${txtFile.id}?alt=media&key=${apiKey}`;
      const textRes = await axios.get(contentUrl);

      setProjectText(textRes.data);
    } catch (err) {
      console.error("Failed to load txt content", err);
    }
  };

  const loadFolderImages = async (folderId, setState = true) => {
    const url = `https://www.googleapis.com/drive/v3/files?q='${folderId}' in parents and mimeType contains 'image/'&fields=files(id)&key=${apiKey}`;
    const res = await axios.get(url);

    const imgs = res.data.files.map(file => ({
      id: file.id,
      src: `https://drive.google.com/thumbnail?id=${file.id}&sz=w2000`,
    }));

    if (setState) setImages(imgs);
    return imgs;
  };

  const loadProjectRoot = async (folderId) => {
    const url = `https://www.googleapis.com/drive/v3/files?q='${folderId}' in parents&fields=files(id,name,mimeType)&key=${apiKey}`;
    const res = await axios.get(url);

    let subFolders = [];
    let directImages = [];

    res.data.files.forEach(file => {
      if (file.mimeType === "application/vnd.google-apps.folder") {
        subFolders.push(file);
      } else if (file.name.toLowerCase().includes("mainimage")) {
        setMainImage({
          src: `https://drive.google.com/thumbnail?id=${file.id}&sz=w2000`
        });
      } else if (file.mimeType.includes("image")) {
        directImages.push({
          src: `https://drive.google.com/thumbnail?id=${file.id}&sz=w2000`
        });
      }
    });

    if (subFolders.length > 0) {
      let collected = [];
      for (let folder of subFolders) {
        const imgs = await loadFolderImages(folder.id, false);
        collected = [...collected, ...imgs];
      }
      setImages(collected);
    } else {
      setImages(directImages);
    }
    setLoading(false);
  };

  const handleCategoryClick = (cat) => {
    sessionStorage.setItem("activeProjectFilter", cat);
    navigate("/projects");
  };

  useEffect(() => {
    const init = async () => {
      const cats = await fetchCategories();
      setCategories(cats);

      const projectId = await findProjectFolder(cats);

      if (projectId) {
        await loadProjectRoot(projectId);
        await fetchProjectText(projectId);
      } else {
        setLoading(false);
      }
    };

    init();
  }, [slug]);

  return (
    <div className={styles.singlePage}>

      {/* FILTER TOP AREA */}
      {!loading && (
        <>
          <ProjectSingleImages
            categoryFilter={
              <div className={styles.filterWrap}>
                <button
                  onClick={() => handleCategoryClick("All")}
                  className={(sessionStorage.getItem("activeProjectFilter") || "All") === "All" ? styles.active : ""}
                >
                  All
                </button>
                {categories.map((cat) => (
                  <button
                    key={cat.id}
                    onClick={() => handleCategoryClick(cat.name)}
                    className={(sessionStorage.getItem("activeProjectFilter") || "All") === cat.name ? styles.active : ""}
                  >
                    {cat.name}
                  </button>
                ))}
              </div>
            }
          >
            {mainImage && (
              <div className={styles.heroRow}>
                {/* LEFT TEXT */}
                <div className={styles.textContent}>
                  <h1>{headingTitle}</h1>
                  {projectText && (
                    <p>{projectText}</p>
                  )}
                </div>

                {/* RIGHT IMAGE */}
                <div className={styles.mainImage}>
                  <img src={mainImage.src} alt={headingTitle} />
                </div>
              </div>
            )}
          </ProjectSingleImages>
        </>
      )}
    </div>
  );
};

export default ProjectSingle;
